import { createContext, useContext } from 'react';

export const RailsContext = createContext();

export function useRailsContext() {
  return useContext(RailsContext);
}
